import React from 'react';
import Button from 'shared/ui/Button';
import CancelButton from 'shared/ui/CancelButton';
import { useDispatch } from 'react-redux';
import { closeModal } from 'store/modals/actions';
import { MODAL_TAGS_IN_AGENTS } from 'store/modals/modals';
import { Wrapper, TagIcon, Title, WrapperButtons } from './styled';

const Header = ({ vulnsTags, hostTags, servicesTags, saveTags }) => {
  const dispatch = useDispatch();

  const onClose = () => dispatch(closeModal(MODAL_TAGS_IN_AGENTS));

  const onSave = () => {
    saveTags({ vuln_tag: vulnsTags, service_tag: servicesTags, host_tag: hostTags });
    onClose();
  };

  return (
    <Wrapper>
      <TagIcon />
      <Title>Manage Tags</Title>
      <WrapperButtons>
        <CancelButton onClick={ onClose }>Cancel</CancelButton>
        <Button onClick={ onSave }>Save</Button>
      </WrapperButtons>
    </Wrapper>
  );
};

export default Header;
